import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useWallet } from "../hooks/useWallet";

export function Login() {
  const { login, isLoading, error, isConnected, isInitializing, jwtToken } = useWallet();
  const navigate = useNavigate();
  const location = useLocation();

  // Only navigate once both isConnected AND jwtToken are ready
  useEffect(() => {
    if (isConnected && jwtToken && !isInitializing) {
      const destination = location.state?.from?.pathname || "/dashboard";
      navigate(destination, { replace: true });
    }
  }, [isConnected, jwtToken, isInitializing, navigate, location]);

  return (
    <div className="flex items-center justify-center min-h-[80vh]">
      <div className="bg-gray-800 rounded-xl shadow-sm border border-gray-700 p-8 w-full max-w-md text-center">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-white mb-2">Connect to KatPack</h1>
          <p className="text-gray-400 text-sm">
            Sign in with your MetaMask wallet on Arbitrum to access the cooperative trading platform.
          </p>
        </div>

        {error && (
          <div className="mb-4 p-3 bg-red-500/20 text-red-400 rounded-lg text-sm">
            {error}
          </div>
        )}

        <button
          onClick={login}
          disabled={isLoading}
          className="w-full flex items-center justify-center gap-3 bg-orange-500 hover:bg-orange-600 disabled:bg-orange-300 text-white font-semibold py-3 px-6 rounded-lg transition-colors"
        >
          {isLoading ? (
            <span>Connecting...</span>
          ) : (
            <>
              <span>🦊</span>
              <span>Connect with MetaMask</span>
            </>
          )}
        </button>

        <p className="mt-4 text-xs text-gray-400">
          Arbitrum Mainnet (chain 42161) or Sepolia Testnet (chain 421614) supported
        </p>
      </div>
    </div>
  );
}
